import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { store } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";
import {
  AJOUTER_PARAMETRE,
  LISTE_PARAMETRE_CONFIG,
} from "../../Utils/constant";
import { SLAConfig } from "./SLAConfigs";

export const SLA = () => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [value, setValue] = useState();
  const param = useConfigStore();

  const config = [
    {
      id: 2,
      description: "Délai de connexion du client en jours",
      param: "TIME_TO_CONNECT",
      defaultValue: param?.data?.TIME_TO_CONNECT,
      message: "Délai de connexion du client appliqué",
    },
  ];

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
  }, []);
  return (
    <div>
      <SLAConfig />

      <p className="text-amber-500 font-mtn text-lg font-semibold">
        Le time to connect
      </p>
      {config.map((item) => (
        <div className="p-3 my-2 border bg-white w-[535px] rounded-xl">
          <div className="lg:flex items-center justify-between gap-4">
            <label className="block mb-2 text-xs  text-gray-900">
              {item.description}
            </label>
            <div className="flex gap-2">
              <input
                defaultValue={item.defaultValue}
                onChange={(e) => setValue(e.target.value)}
                type="text"
                className="w-40 text-center input input-bordered h-10 text-sm font-semibold"
              />
              <button
                type="submit"
                onClick={() => {
                  store(`${AJOUTER_PARAMETRE}`, "application/json", {
                    designation: item.param,
                    valeur: value,
                  })
                    .then((res) => {
                      if (res.status === 200) {
                        toast.success(item.message);
                        setIsSubmit(false);
                        param.getData(LISTE_PARAMETRE_CONFIG);
                      }
                    })
                    .catch((err) => {
                      if (err.response.status === 500) {
                        setIsSubmit(false);
                        toast.error(err.response.data.donnee);
                      }
                    });
                }}
                disabled={isSubmit ? true : false}
                className={`${
                  !isSubmit
                    ? "text-black bg-main"
                    : "text-slate-800 bg-slate-200 "
                } ml-auto px-3 py-2 rounded-md font-normal text-xs`}
              >
                {!isSubmit ? "Appliquer" : "Veuillez patientez..."}{" "}
                {isSubmit ? (
                  <span className="loading loading-dots loading-xs"></span>
                ) : null}
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
